// Modules
import React from "react";

import { AppointmentCard, Base } from "./HorizontalAppointmentList.styles";
import { Props } from "./HorizontalAppointmentList.types";

const HorizontalAppointmentList = ({ appointments, className, ...rest }: Props) => {
  return (
    <Base className={className} {...rest}>
      {appointments.map((appointment) => (
        <AppointmentCard key={appointment.appointmentId} appointment={appointment} />
      ))}
    </Base>
  );
};

export default HorizontalAppointmentList;
